"use client"

import Image from "next/image"
import { useRouter } from "next/navigation"
import { Avatar } from "@heroui/avatar"
import { Divider, Tooltip } from "@heroui/react"
import { User } from "@heroui/user"
import { signOut, useSession } from "next-auth/react"

import sessionicon from "@/assets/sessionicon.png"
import userfav from "@/assets/userfav.png"
import userhis from "@/assets/userhis.png"
import userlogout from "@/assets/userlogout.png"

export default function UserMenuClient() {
  const { data: session } = useSession()
  const router = useRouter()
  return (
    <Tooltip
      delay={0}
      closeDelay={100}
      content={
        <div className="h-[150px] p-2">
          <div>
            <User
              avatarProps={{
                size: "sm",
                src: session?.user?.image ?? "",
              }}
              classNames={{
                name: "text-[14px] text-[#4E5969] ",
                description: "text-default-500",
              }}
              // description={session?.user?.email ?? ""}
              name={session?.user?.email ?? ""}
            />
          </div>
          <div
            onClick={() => router.push("/favorites")}
            className="mt-2 flex h-[35px] cursor-pointer items-center gap-2 rounded px-2 text-[#1D2129] hover:bg-[#F2F3F5]"
          >
            <Image src={userfav} alt="userfav" width={18} height={18} />
            Favorites
          </div>
          {/* <div
            onClick={() => router.push("/recents")}
            className="mt-2 flex h-[35px] cursor-pointer items-center gap-2 rounded px-2 text-[#1D2129] hover:bg-[#F2F3F5]"
          >
            <Image src={userhis} alt="userhis" width={18} height={18} />
            Recents
          </div> */}
          <div className="mt-2 opacity-50">
            <Divider />
          </div>
          <div
            onClick={() => signOut({ callbackUrl: "/" })}
            className="mt-2 flex h-[35px] cursor-pointer items-center gap-2 rounded px-2 text-[#f53f3f] hover:bg-[#F2F3F5]"
          >
            <Image src={userlogout} alt="userlogout" width={18} height={18} />
            Log Out
          </div>
        </div>
      }
    >
      <div className="flex h-[33px] min-w-[89px] cursor-pointer items-center justify-center gap-1 rounded-[4px] bg-[#F7F8FA] px-2 hover:bg-[#E5E6EB]">
        <div className="flex h-auto w-[16px] items-center">
          <Avatar
            src={session?.user?.image ?? ""}
            size="sm"
            classNames={{
              base: "size-[16px]",
            }}
          ></Avatar>
        </div>
        <span className="max-w-[89px] min-w-[30px] truncate text-sm font-medium">
          {session?.user?.name || session?.user?.email}
        </span>
        <Image src={sessionicon} alt="sessionicon" width={12} height={12} />
      </div>
    </Tooltip>
  )
}
